<template>
  <div class="multi-upload-img">
    <el-upload
      ref="productsDetailList"
      :action="uploadUrl"
      list-type="picture-card"
      class
      :class="{ hide: hideUpload, hideRemove: !hasDel }"
      :file-list="fileList"
      :on-preview="handlePictureCardPreview"
      :on-remove="handleRemove"
      :multiple="multiple"
      :on-change="onChange"
      :before-upload="beforeUpload"
      :auto-upload="true"
      :limit="limit"
      :on-exceed="handleExceed"
      :on-success="handlePictureSuccess"
      :on-error="errFunction"
      :before-remove="beforeRemove"
      :headers="headers"
      :accept="accept"
    >
      <div @click.stop="" class="view" v-viewer="options" v-show="false">
        <img :src="viewUrl" />
      </div>
      <i class="el-icon-plus"></i>
    </el-upload>
    <div class="tip">最多上传{{limit}}个附件，格式仅支持{{accept}}，每个附件大小不超过{{imageSize}} M。</div>
    <template>
      <div class="error" v-show="uploadTips">请选择图片</div>
    </template>
  </div>
</template>

<script>
  import api from "../../api/product";
import { epecToken } from '../../utils/globalData'
import Viewer from 'v-viewer'
import './viewer.css'
import Vue from 'vue'
Vue.use(Viewer)
export default {
  name: 'multiImageUpload',
  props: {
    // 限制上传文件大小
    imageSize: {
      type: Number,
      default: 8
    },
    // 允许上传得文件类型
    accept: {
      type: String,
      default: '.jpeg, .jpg, .png'
    },
    // 上传图片的接口
    uploadUrl: {
      type: String,
      default: api.fileUpload
    },
    // 限制上传图片个数
    limit: {
      type: Number,
      default: 1
    },
    // 用于回显的图片地址
    // 需要回显传入的格式必须是: [{url:'地址',name:'名字'}] elementUI 回显图片要求 [{url:'地址'}]
    url: {
      type: Array,
      default: function() {
        return []
      }
    },
    // 是否有删除按钮
    hasDel: {
      type: Boolean,
      default: true
    },
    // 是否有上传功能(只有在查看的时候传值false,这时候也没删除功能)
    hasUpload: {
      type: Boolean,
      default: true
    },
    // 是否支持多选图片
    multiple: {
      type: Boolean,
      default: false
    },
    // 必填项时需传verify：true ,uploadTips：false,并在父组件保存按钮加个判断，非必填这些不写
    // <el-form-item 需要加 class="is-required"> 小红点 <el-form-item 需要加 is-required> 小红点
    // 是否必填验证
    verify: {
      type: Boolean,
      default: false
    },
    // 提示信息
    uploadTips: {
      type: Boolean,
      default: false
    },
    options: {
      type: Object,
      default: function() {
        return { navbar: false, zIndex: 99999999999999999 }
      }
    }
  },
  data() {
    return {
      hideUpload: false,
      fileList: [],
      showImgViewer: false,
      imgPreviewList: [],
      headers: epecToken,
      imgInfo: [],
      // v-view的url
      viewUrl: '',
      imgUrl: ''
    }
  },
  mounted() {
    // 单张的时候需要判断
    if (!this.hasUpload) {
      this.hideUpload = true
      return false
    } else {
      this.hideUpload = false
    }
    /* if (this.url) {
      this.url.forEach((ele) => {
        this.fileList.push({ url: ele.url, name: "xxx.png" });
        this.imgInfo.push(ele);
      });
      if (!this.hasUpload) {
        this.hideUpload = true;
        return false;
      } else {
        this.hideUpload = false;
      }
      this.hideUpload = this.fileList.length >= this.limit;
    } */
  },
  watch: {
    url(val) {
      if (val) {
        this.fileList = []
        val.forEach(ele => {
          // 封装组件后台不给name属性,需要前端自己给名字就给 xxx,png 吧
          this.fileList.push({ url: ele, name: 'xxx.png' })
          // this.imgInfo.push(ele.url);
        })
        //console.log(this.fileList, "this.fileList");
        this.imgInfo = [...this.fileList.map(item => item.url)]
        //console.log(this.imgInfo, "this.imgInfo");
        if (!this.hasUpload) {
          this.hideUpload = true
          return false
        } else {
          this.hideUpload = false
        }
        this.hideUpload = this.fileList.length >= this.limit
      }
    },
    hasUpload(val) {
      if (!val) {
        this.hideUpload = true
        return false
      } else {
        this.hideUpload = false
      }
      this.hideUpload = this.fileList.length >= this.limit
    }
  },
  methods: {
    // 显示图片预览弹层
    show() {
      const viewer = this.$el.querySelector('.view').$viewer
      viewer.show()
    },
    // 放大
    handlePictureCardPreview(file) {
      this.viewUrl = file.url
      this.show()
    },
    // 关闭图片查看器
    closeImgViewer() {
      this.showImgViewer = false
    },
    // 改变图片的钩子
    onChange(file, fileList) {
      console.log(file, fileList)
      if (this.verify) {
        this.$emit('update:uploadTips', false)
      }
      if (!this.hasUpload) {
        this.hideUpload = true
        return false
      } else {
        this.hideUpload = false
      }
      this.hideUpload = this.hasUpload && fileList.length >= this.limit
    },
    // 上传文件格式一律转为小写
    commonHandleCheck(val) {
      let testmsg = val.substring(val.lastIndexOf('.') + 1)
      testmsg && (testmsg = testmsg.toLowerCase())
      return testmsg
    },
    // 上传之前图片验证
    beforeUpload(file) {
      let testmsg = this.commonHandleCheck(file.name)
      console.log(testmsg, 'testmsg')
      const isJPEG = testmsg === 'jpeg'
      const isJPG = testmsg === 'jpg'
      const isPNG = testmsg === 'png'
      const isGIF = testmsg === 'gif'
      const isBMP = testmsg === 'bmp'
      const isImageSize = file.size / 1024 / 1024 < this.imageSize
      if (!isJPG && !isPNG && !isGIF && !isJPEG && !isBMP) {
        this.$message.error('上传图片只能是 JPG、JPEG、PNG、GIF、BMP 格式!')
        return false
      }
      if (!isImageSize) {
        this.$message.error(`上传图片大小不能超过 ${this.imageSize}MB!`)
        return false
      }
      return (isJPG || isPNG || isGIF || isJPEG || isBMP) && isImageSize
    },
    // 上传成功的钩子
    handlePictureSuccess(response, file, fileList) {
      console.log('上传成功钩子的response:', response, file, fileList)
      this.imgInfo.push(response.data.url)
      this.$emit('handleimgInfo', this.imgInfo)
    },
    // 移除的钩子
    handleRemove(file, fileList) {
      console.log(file, fileList, 'file3')
      if (!this.hasUpload) {
        this.hideUpload = true
        return false
      } else {
        this.hideUpload = false
      }
      this.hideUpload = this.hasUpload && fileList.length >= this.limit
      // 处理新上传的图片和默认展示的图片
      if (file.response?.data) {
        const { url } = file.response.data
        for (let index = 0; index < this.imgInfo.length; index++) {
          if (this.imgInfo[index] == url) {
            this.imgInfo.splice(index, 1)
            break
          }
        }
      } else {
        for (let index = 0; index < this.imgInfo.length; index++) {
          if (this.imgInfo[index] == file.url) {
            this.imgInfo.splice(index, 1)
            break
          }
        }
      }

      this.$emit('handleimgInfo', this.imgInfo)
      // 编辑回显中的图片也需要考虑在内
      if (this.verify && fileList.length == 0) {
        this.$emit('update:uploadTips', true)
      }
      if (this.verify && fileList.length != 0) {
        this.$emit('update:uploadTips', false)
      }
    },
    // 移除前的钩子
    beforeRemove(file, fileList) {
      console.log(file, fileList, 'file')
      if (file && file.status === 'success') {
        return this.$confirm(`确定移除该文件吗？`, '提示')
      }
    },
    // 文件超出个数限制时的钩子
    handleExceed() {
      this.$message.error(`当前限制最多选择 ${this.limit} 个图片`)
    },
    // 上传失败的钩子
    errFunction() {
      this.$message.error('保存失败')
    }
  }
}
</script>
<style lang="scss" scoped>
.multi-upload-img {
  .tip{
    margin-top: 10px;
    color: #999;
  }
  /* 上传图片按钮 */
  .hide ::v-deep .el-upload--picture-card {
    display: none;
  }
  /* .hideRemove ::v-deep .el-upload-list__item-actions {
    display: none;
  } */
  /* 删除按钮 */
  .hideRemove ::v-deep .el-upload-list__item-delete {
    display: none !important;
  }
  /* 去掉动画 */
  ::v-deep .el-upload-list__item-actions {
    transition: none;
  }
  /* ::v-deep .el-upload-list__item-actions {
    &:hover {
      .el-upload-list__item-preview {
        display: none;
      }
    }
  } */
  ::v-deep .el-upload-list__item-status-label {
    display: none;
  }

  /* ::v-deep .el-upload-list__item-preview {
    display: none;
  } */

  ::v-deep .el-upload-list__item {
    transition: none;
  }
  /* 不展示 按 delete 键可删除 */
  ::v-deep .el-icon-close-tip {
    display: none !important;
  }
  ::v-deep .el-upload-list--picture-card .el-upload-list__item {
    border-radius: 0;
  }
  ::v-deep .el-upload-list__item {
    border-radius: 0;
  }
  ::v-deep .el-upload {
    border-radius: 0;
  }
  .error {
    color: #f0250f;
  }
}
</style>
